import React from 'react';
import AccountingModule from './accounting/Accounting';
const AccountsReceivable = (props) => (React.createElement(AccountingModule, Object.assign({ ledgerType: "receivables" }, props)));
export default AccountsReceivable;
